import { Badge, Grid, makeStyles, Tab, Tabs } from '@material-ui/core'
import PrimaryButton from 'components/common/buttons/PrimaryButton'
import SecondaryButton from 'components/common/buttons/SecondaryButton'
import NotificationCenterBellButton from 'components/Header/NotificationCenterBellButton'
import useFeatureFlags from 'hooks/useFeatureFlags'
import useRolePermissions from 'hooks/useRolePermissions'
import React from 'react'
import { useTranslation } from 'react-i18next'
import AppLogo from './AppLogoV2'
import AppMenuButton from './AppMenu/AppMenuButton'
import useAppHeader from './useAppHeader'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    height: 'var(--app-header-v2-height)'
  },
  logoAndTabsSection: {
    display: 'flex',
    alignItems: 'center'
  },
  tab: {
    height: 'var(--app-header-v2-height)',
    minWidth: 100,
    fontWeight: 'bold',
    textTransform: 'none'
  },
  indicator: {
    backgroundColor: '#3c52ef',
    height: 3
  },
  selected: {
    color: '#3c52ef'
  },
  badgeRoot: {
    marginLeft: 20,
    marginRight: 10
  },
  badge: {
    fontFamily: 'Dazzed',
    fontWeight: 600
  },
  actionsAndProfileSection: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'nowrap'
  },
  invitePatientButton: {
    marginRight: 10
  },
  createRecordsAppPtButton: {
    marginRight: 10
  }
}))

const AppHeaderV2 = () => {
  const { t } = useTranslation()
  const classes = useStyles()

  const { permissions } = useRolePermissions()
  const { createRecordsOnlyPatients: createRecordsOnlyPatientsFF, notificationCenter: notificationCenterFF } =
    useFeatureFlags()

  const { selectedTab, tabs, handleTabChange, handleClickCreateRecordsPatient, handleClickInvitePatient } =
    useAppHeader({ source: 'AppHeaderV2' })

  return (
    <Grid container className={classes.root}>
      <Grid item className={classes.logoAndTabsSection}>
        <AppLogo />
        {notificationCenterFF && (
          <div style={{ padding: '0 24px' }}>
            <NotificationCenterBellButton variant="light" />
          </div>
        )}
        <Tabs
          value={tabs.some(tab => tab.to === selectedTab) ? selectedTab : false}
          classes={{ indicator: classes.indicator }}
          onChange={handleTabChange}
        >
          {tabs.map(tab => (
            <Tab
              key={tab.key}
              id={tab.id}
              disableRipple
              classes={{
                root: classes.tab,
                selected: classes.selected
              }}
              value={tab.to}
              to={tab.to}
              label={
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {tab.icon && <span style={{ marginRight: 8 }}>{tab.icon}</span>}
                  {tab.displayName}
                  {tab.badgeValue > 0 ? (
                    <Badge
                      badgeContent={tab.badgeValue}
                      color="error"
                      classes={{ root: classes.badgeRoot, badge: classes.badge }}
                    />
                  ) : null}
                </div>
              }
            />
          ))}
        </Tabs>
      </Grid>
      <Grid item className={classes.actionsAndProfileSection}>
        {createRecordsOnlyPatientsFF && permissions.invitePatient && (
          <div className={classes.createRecordsAppPtButton}>
            <SecondaryButton
              label={t('common.appHeader.createPatientButton')}
              onClick={handleClickCreateRecordsPatient}
              height="35px"
              width="174px"
              fontWeight="500"
            />
          </div>
        )}
        {permissions.invitePatient && (
          <div className={classes.invitePatientButton}>
            <PrimaryButton
              label={t('common.appHeader.invitePatientBtn')}
              height="35px"
              width="174px"
              fontWeight="500"
              onClick={handleClickInvitePatient}
            />
          </div>
        )}
        <AppMenuButton />
      </Grid>
    </Grid>
  )
}

export default AppHeaderV2
